import CancelationPolicy from "./CancelationPolicy";


export default {
    name     : 'dialog_cancelation_policy',
    component: CancelationPolicy,
    dialog   : {
        'max-width': "500px"
    }
}
